export const environment = {
  hmr: false,
  production: false,
  api: 'https://apilocaviahml.infosistemas.com.br:7014/api',
  encryptSecretKey:
    'JNQg$HPvP_,?!1Oe<rQ5D5i}iy:n)@INFO`Qv<E_$.]BL5HJdR-BI22}yn5p)z9_ao?7', //chave utilizada no backend
};
